// Advances the in-loop calendar. Every action consumes one or more days.

import type { LoopState } from "../types"

export function advanceDays(loop: LoopState, days: number): LoopState {
  if (days < 1) {
    throw new Error(`advanceDays requires at least 1 day, received ${days}`)
  }
  return { ...loop, currentDay: loop.currentDay + days }
}
